import { createFileRoute } from "@tanstack/react-router";
import { LearnArticlePage } from "#/features/learn/components/learn-article-page";

export const Route = createFileRoute("/_app/learn/$slug")({
	component: LearnArticleRoute,
});

function LearnArticleRoute() {
	const { slug } = Route.useParams();
	return <LearnArticlePage slug={slug} />;
}
